// TOP LEVEL IMPORTS
import React from 'react';
import styled from 'styled-components';
// COMPONENTS
import Row from 'components/common/Row';
import Col from 'components/common/Col';
import TextInput from 'components/inputs/TextInput';
import CountryInput from 'components/inputs/CountryInput';
import StatesInput from 'components/inputs/StatesInput';
import TextAreaInput from 'components/inputs/TextAreaInput';
import ClientStatusInput from 'components/inputs/ClientStatusInput';
import Button from 'components/common/Button';
import ErrorList from 'components/common/ErrorList';
import FormProps from 'components/render-props/form-props';
import FormItem from 'components/common/FormItem';
import ImageUploadInput from 'components/inputs/ImageUploadInput';
import ClientTagsInput from 'components/inputs/ClientTagsInput';

// CONSTANTS & DESCTRUCTURING
// ====================================
const ButtonContainer = styled.div`
  text-align: center;
  margin-top: 10px;
`;

// EXPORTED COMPONENT
// ====================================
class ClientForm extends React.PureComponent {
  state = {
    email: this.props.client && this.props.client.email,
    firstName: this.props.client && this.props.client.firstName,
    lastName: this.props.client && this.props.client.lastName,
    street1: this.props.client && this.props.client.street1,
    street2: this.props.client && this.props.client.street2,
    zip: this.props.client && this.props.client.zip,
    country: this.props.client && this.props.client.country,
    state: this.props.client && this.props.client.state,
    city: this.props.client && this.props.client.city,
    phone: this.props.client && this.props.client.phone,
    website: this.props.client && this.props.client.website,
    image: this.props.client && this.props.client.image,
    status: (this.props.client && this.props.client.status) || 'Lead',
    description: this.props.client && this.props.client.description,
    clientTags: this.props.client && this.props.client.clientTags.map(tag => tag._id),
  };

  onChange = newValue => {
    // uupdate local state with an object that is the field name and value, e.g { email: anthony@google.com } coming from the email input
    this.setState(newValue);
  };

  onSubmit = newValue => {
    this.props.handleSubmit(this.state);
  };

  render() {
    return (
      <form onSubmit={this.onSubmit} id="user-form">
        <Row gutter={10}>
          <Col xs={24}>
            {' '}
            <FormItem
              containerProps={{
                style: { display: 'flex', justifyContent: 'center' },
              }}
            >
              <ImageUploadInput
                cloudinaryOptions={{ croppingAspectRatio: 0.5, maxImageHeight: 150, maxImageWidth: 150 }}
                value={this.state.image}
                onChange={image => this.onChange({ image })}
              />
            </FormItem>
          </Col>
          <Col xs={24} md={12}>
            <FormItem>
              <label>First Name</label>
              <TextInput onChange={firstName => this.onChange({ firstName })} value={this.state.firstName} />
            </FormItem>
          </Col>
          <Col xs={24} md={12}>
            <FormItem>
              <label>Last Name</label>
              <TextInput onChange={lastName => this.onChange({ lastName })} value={this.state.lastName} />
            </FormItem>
          </Col>
          <Col xs={24} md={12}>
            <FormItem>
              <label>Email</label>
              <TextInput onChange={email => this.onChange({ email })} value={this.state.email} />
            </FormItem>
          </Col>
          <Col xs={24} md={12}>
            <FormItem>
              <label>Website</label>
              <TextInput onChange={website => this.onChange({ website })} value={this.state.website} />
            </FormItem>
          </Col>

          <Col xs={16}>
            <FormItem>
              <label>Street 1</label>
              <TextInput onChange={street1 => this.onChange({ street1 })} value={this.state.street1} />
            </FormItem>
          </Col>
          <Col xs={8}>
            <FormItem>
              <label>Street 2</label>
              <TextInput onChange={street2 => this.onChange({ street2 })} value={this.state.street2} />
            </FormItem>
          </Col>
          <Col xs={12}>
            <FormItem>
              <label>City</label>
              <TextInput onChange={city => this.onChange({ city })} value={this.state.city} />
            </FormItem>
          </Col>
          <Col xs={12}>
            <FormItem>
              <label>Postal Code</label>
              <TextInput onChange={zip => this.onChange({ zip })} value={this.state.zip} />
            </FormItem>
          </Col>
          <Col xs={16}>
            <FormItem>
              <FormItem>
                <label>Country</label>
                <CountryInput onChange={country => this.onChange({ country })} value={this.state.country} />
              </FormItem>
            </FormItem>
          </Col>
          <Col xs={8}>
            <FormItem>
              <label>State/Province</label>
              <TextInput onChange={state => this.onChange({ state })} value={this.state.state} />
            </FormItem>
          </Col>
          <Col xs={12}>
            <FormItem>
              <label>Phone</label>
              <TextInput onChange={phone => this.onChange({ phone })} value={this.state.phone} />
            </FormItem>
          </Col>
          <Col xs={12}>
            <FormItem>
              <label>Status</label>
              <ClientStatusInput onChange={status => this.onChange({ status })} value={this.state.status} />
            </FormItem>
          </Col>
          <Col xs={24}>
            <FormItem>
              <label>Client Notes</label>
              <TextAreaInput
                onChange={e => this.onChange({ description: e.target.value })}
                value={this.state.description}
              />
            </FormItem>
          </Col>
          <Col xs={24}>
            <FormItem>
              <label>Client Tags</label>
              <ClientTagsInput onChange={clientTags => this.setState({ clientTags })} value={this.state.clientTags} />
            </FormItem>
          </Col>
        </Row>

        <ButtonContainer>
          <Button disabled={this.props.loading} loading={this.props.loading} onClick={this.onSubmit} fullWidth>
            {!this.props.loading ? this.props.onOkText : 'Submitting...'}
          </Button>
        </ButtonContainer>
        <ErrorList errors={this.props.errors} />
      </form>
    );
  }
}

// PROPS
// ====================================
ClientForm.defaultProps = {
  onOkText: 'Submit',
  loading: false,
  errors: [],
};

// EXPORT
// ====================================
export default ClientForm;



// WEBPACK FOOTER //
// ./src/components/forms/ClientForm/index.js